import type { Policy, PolicyKind } from '@nucleus-commerce/api-client/admin';

import { FIXED_POLICY_KINDS } from './policy-rules';

export interface PolicyRow {
  kind: PolicyKind;
  policy: Policy | null;
}

/** The fixed kinds in footer order, created or not, then every custom document by title. */
export function policyRows(policies: readonly Policy[]): PolicyRow[] {
  const fixed = FIXED_POLICY_KINDS.map<PolicyRow>((kind) => ({
    kind,
    policy: policies.find((p) => p.kind === kind) ?? null,
  }));
  const custom = policies
    .filter((p) => p.kind === 'custom')
    .sort((a, b) => a.title.localeCompare(b.title))
    .map<PolicyRow>((policy) => ({ kind: 'custom', policy }));
  return [...fixed, ...custom];
}
